import React, { useMemo } from "react";
import { COMPANY_STATS } from "../../../data/products";
import { useParallax } from "../../../hooks/useParallax";
import AnimatedSection from "../../common/AnimatedSection/AnimatedSection";
import { useLanguage } from "../../../context/LanguageContext";
import "./HeroSection.css";

export const HeroSection: React.FC = () => {
  const parallaxRef = useParallax({ speed: 0.5, direction: 'down' });
  const { t } = useLanguage();

  

  return (
    <section id="hero" className="hero floating-particles geometric-shapes">
      {/* Enhanced Background with Multiple Layers */}
      <div className="hero__background" ref={parallaxRef}>
        <div className="hero__overlay"></div>
        <div className="morphing-blob"></div>
      </div>

      {/* Orbiting Hero Images around text (inline moved below title) */}

      {/* Light Rays Effect */}
      <div className="hero__light-rays"></div>

      {/* Floating Particles */}
      <div className="hero__particles">
        <div className="hero__particle"></div>
        <div className="hero__particle"></div>
        <div className="hero__particle"></div>
        <div className="hero__particle"></div>
        <div className="hero__particle"></div>
        <div className="hero__particle"></div>
        <div className="hero__particle"></div>
        <div className="hero__particle"></div>
        <div className="hero__particle"></div>
      </div>

      {/* Orbiting Elements */}
      <div className="hero__orbiting-elements">
        <div className="hero__orbiting-element"></div>
        <div className="hero__orbiting-element"></div>
        <div className="hero__orbiting-element"></div>
      </div>

      {/* Side Images replaced by Ellipse Gallery */}

      <div className="container">
        <div className="hero__content">
          {/* Brand Section (restore text logo) */}
          <AnimatedSection animation="fadeIn" delay={0.2}>
            <div className="hero__brand">
              <h1 className="hero__brand-title">
                <span className="hero__brand-esf">ESF</span>
                <span className="hero__brand-otomotiv">OTOMOTİV</span>
              </h1>
              <p className="hero__brand-tagline">{t('hero.tagline')}</p>
            </div>
          </AnimatedSection>

          {/* Main Title and Description */}
          <AnimatedSection animation="fadeInUp" delay={0.4}>
            <div className="hero__main">
              
            </div>
          </AnimatedSection>

          {/* Inline strip images between text and stats */}
          <AnimatedSection animation="fadeIn" delay={0.6}>
            <StripHeroImagesInline />
          </AnimatedSection>

          {/* Stats Section */}
          <AnimatedSection animation="fadeInUp" delay={0.8} threshold={0.3}>
            <div className="hero__stats">
              <div className="hero__stats-grid animated-section--staggered">
                {COMPANY_STATS.map((stat, index) => (
                  <div
                    key={index}
                    className="hero__stat animated-section__item"
                  >
                    <div className="hero__stat-number">{stat.number}</div>
                    <div className="hero__stat-label">{t(`hero.stats.${stat.id}`)}</div>
                  </div>
                ))}
              </div>
            </div>
          </AnimatedSection>

          {/* Scroll Indicator */}
          <AnimatedSection animation="fadeIn" delay={1.2}>
            <div className="hero__scroll-indicator">
              <div className="hero__scroll-mouse">
                <div className="hero__scroll-wheel"></div>
              </div>
              <p>{t('hero.scroll')}</p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

// removed top overlay variant

const StripHeroImagesInline: React.FC = () => {
  const images = useMemo(() => Array.from({ length: 12 }, (_, i) => `${process.env.PUBLIC_URL}/images/hero/${i + 1}.png`), []);
  return (
    <div className="hero__strip-images hero__strip-images--inline" aria-hidden>
      <div className="hero__strip-track hero__strip-track--inline">
        <div className="hero__strip-segment">
          {images.map((src, i) => (
            <img key={`seg1-inline-${i}`} src={src} className="hero__strip-image" alt="" />
          ))}
        </div>
        <div className="hero__strip-segment">
          {images.map((src, i) => (
            <img key={`seg2-inline-${i}`} src={src} className="hero__strip-image" alt="" />
          ))}
        </div>
      </div>
    </div>
  );
};
